export default "__VITE_ASSET__DOqCoKDx__"